module.exports = __webpack_public_path__ + "img/stock3.e53fb51e.png";